import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {HttpClient} from "@angular/common/http";
import { ClaimDocumentsComponent } from "../../claim-documents/claim-documents.component";
import { SideMenuService } from "src/app/services/side-menu.service";
import { ClaimService } from "src/app/services/claim.service";
import { DocumentHelperService } from "src/app/services/document-helper.service";
import { DocumentFormFactoryService } from "src/app/services/document-form-factory.service";
import { SpinnerService } from "src/app/core/spinner/spinner.service";
import { TransactionInfoService } from "src/app/services/transaction-info.service";
import { ActivatedRoute, Router } from "@angular/router";
import { TransactionInfo } from "src/app/model/transaction-info.model";
import {Claim} from "../../../model/claim.model";

declare var $: any;

@Component({
    selector: 'app-home-upload-document',
    templateUrl: './home-upload-document.component.html',
    styleUrls: ['./home-upload-document.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class HomeUploadDocumentComponent extends ClaimDocumentsComponent implements OnInit {

    public upLoadFileModel: FormGroup;
    showTotalBox = false;
    showForm2DownloadLinks = false;
    transactionInfo: TransactionInfo;
    claim: Claim;
    
    constructor(private fb: FormBuilder,
                public sideMenuService: SideMenuService, 
                claimService: ClaimService,
                documentHelperService: DocumentHelperService,
                transactionInfoService: TransactionInfoService,
                http: HttpClient,
                documentFormFactoryService: DocumentFormFactoryService, 
                spinnerService: SpinnerService, 
                modalService: NgbModal, 
                private activatedRoute: ActivatedRoute,
                private router: Router) {
        super(claimService, documentHelperService, transactionInfoService, http, documentFormFactoryService, spinnerService, modalService);
        this.setCurrentClaimType(this.claimService.getClaim().getSelectedClaimTypesList()[0]);
        this.transactionInfo = transactionInfoService.getTransactionInfo();
        this.claim = this.claimService.getClaim();
    }

    ngOnInit() {
        this.pushGAUploadDocumentsView();

        this.upLoadFileModel = this.fb.group(
            {
                airTicket: [],
                carrierCertificate: [],
                otherItems: this.fb.array([this.createItem()])

            });
            super.ngOnInit();
            if(this.formBuilder != null && this.formBuilder.getRequiredDocuments() != null && this.formBuilder.getRequiredDocuments().findIndex((doc)=>{return doc.getId() === "ECFORMTWO"}) > -1){
                this.showForm2DownloadLinks = true;
            }
    }

    addFile() {
        let items = this.upLoadFileModel.get('otherItems') as FormArray;
        items.push(this.createItem());
    }

    createItem(): FormGroup {
        return this.fb.group({
            otherFile: [],
        });
    }

    showModal() {
        this.showTotalBox = true;
    }

    getData(msg) {
        this.showTotalBox = msg;
    }

    goToNext() {
        super.goToNextDynamic(this.router, this.activatedRoute);
    }

    goBack() {
        super.goBackDynamic(this.router, this.activatedRoute);
    }

    pushGAUploadDocumentsView() {
        let pageStep = this.transactionInfo.getGaPageStep() + ' - Document Upload';
        let vPath = '/claim/' + this.transactionInfo.getGaVPath() + '/documents';

        (<any>window).dataLayer = (<any>window).dataLayer || [];
        (<any>window).dataLayer.push({
            'pageStep': pageStep,
            'vPath': vPath,
            'event': 'vpageview',
            'ecommerce': {
              'checkout': {
                  'actionField': {'step': 5}	//Step6-DocumentUpload
              }
            }
        });
      }
}
